import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { appReducer } from 'scenes/App';
import { consentReducer } from 'scenes/Consent';
import { preferencesCenterReducer } from 'scenes/PreferencesCenter';
import { localizationReducer } from 'services/localization';

export const rootReducer = combineReducers({
  app: appReducer,
  preferences: preferencesCenterReducer,
  consent: consentReducer,
  localization: localizationReducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
});

export type StoreType = ReturnType<typeof rootReducer>;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
